/* Bruma Motors vehicle finder: make every brand dropdown list all brands from window.aeroDB
   (the homepage finder ships with a fixed list of brands in its HTML). */
(function () {
  function sync() {
    var db = window.aeroDB;
    if (!db) return;
    var brands = Object.keys(db).sort(function (a, b) {
      return a.localeCompare(b, undefined, { numeric: true, sensitivity: 'base' });
    });
    var sels = document.querySelectorAll('select[id^="aeroBrand-"]');
    for (var i = 0; i < sels.length; i++) {
      var sel = sels[i];
      if (sel.options.length <= 1) continue; /* empty lists are filled by the finder itself */
      var have = {};
      for (var j = 0; j < sel.options.length; j++) have[sel.options[j].value] = true;
      var missing = brands.filter(function (b) { return !have[b]; });
      if (!missing.length) continue;
      var current = sel.value;
      var placeholder = sel.options[0] && sel.options[0].value === '' ? sel.options[0] : null;
      var frag = document.createDocumentFragment();
      if (placeholder) frag.appendChild(placeholder);
      brands.forEach(function (b) {
        var o = document.createElement('option');
        o.value = b; o.textContent = b;
        frag.appendChild(o);
      });
      sel.innerHTML = '';
      sel.appendChild(frag);
      sel.value = current;
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', sync);
  else sync();
})();
